import { Link } from "react-router-dom";
import PageTitle from "../../components/pagetitle/PageTitle";
import shape1 from "../../images/shapes/shape_space_4.svg";
import shape2 from "../../images/shapes/shape_angle_3.webp";
function Pagenotfound() {
  return (
    <main className="page_content about-page">
      <PageTitle pageTitle="Page Not Found" />

      <section className="faq_section section_decoration pt-5">
        <div className="container">
          <div className="heading_block text-center"></div>

          <div style={{ padding: "80px 20px", textAlign: "center" }}>
            <h1 style={{ fontSize: "4rem", color: "#dc3545" }}>404</h1>
            <h2>Oops! Page not found.</h2>
            <p>The page you're looking for doesn’t exist or has been moved.</p>

            <Link className="btn" to="/">
              <span className="btn_label" data-text="Go Back Home">
                Go Back Home
              </span>
              <span className="btn_icon">
                <i className="fa-solid fa-arrow-up-right"></i>
              </span>
            </Link>
          </div>
        </div>

        <div className="decoration_item shape_image_1">
          <img src={shape1} alt=" Shape" />
        </div>
        <div className="decoration_item shape_image_2">
          <img src={shape2} alt=" Shape Angle" />
        </div>
      </section>
    </main>
  );
}

export default Pagenotfound;
